module.exports = __webpack_public_path__ + "static/media/Fireworks Guy.72102eb5.jpg";